module.exports = __webpack_public_path__ + "img/we.01cd8a12.png";